import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppService } from 'app/app.service';
import { Usuario } from 'app/interfaces/usuario';
import { UsuarioHttpService } from 'app/main/usuario/usuario-http.service';
import handleErrorMessage from 'app/utils/error-message-handler';
import { MessageService } from 'app/utils/toastr-custom/message.service';
import { Subscription } from 'rxjs';
import { UsuarioService } from '../usuario.service';
import { Grupo } from 'app/interfaces/grupo';
import { GrupoHttpService } from 'app/main/grupo/grupo-http.service';

@Component({
  selector: 'app-usuario-list',
  templateUrl: './usuario-list.component.html',
  styleUrls: ['./usuario-list.component.scss'],
})
export class UsuarioListComponent implements OnInit {
  usuarios = [] as Usuario[];
  subscription: Subscription;
  public pageIndex: number;
  grupos = [] as Grupo[];

  constructor(
    private _appService: AppService,
    private _activatedRoute: ActivatedRoute,
    public usuarioService: UsuarioService,
    private _grupoHttpService: GrupoHttpService,
    private _usuarioHttpService: UsuarioHttpService,
    private _messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.getUsuarios();
    this.getGrupos();
  }

  getGrupos() {
    this._grupoHttpService.getGrupos().subscribe({
      next: (result: Grupo[]) => {
        this.grupos = result.sort((a, b) => a.nome.localeCompare(b.nome, 'pt-BR', { sensitivity: 'base' }));
      },
      error: error => {
        console.log(error);
        handleErrorMessage(this._messageService, error);
      },
    });
  }

  /**
   * Função para buscar todos usuários;
   */
  getUsuarios() {
    // get data from resolver;
    this.subscription = this._activatedRoute.data.subscribe(result => {
      this.usuarioService.state.data = result.usuarios;
      this.pageIndex = this.usuarioService.state.data.number + 1;
      this.usuarios = Object.assign([], this.usuarioService.state.data.content);
    });
  }

  /**
   * Função para filtrar a table;
   */
  filtrar(page = 1) {
    this._appService.progressSpinnerDlg = true;

    const filtro = this.stateFiltro;

    if (this.stateFiltro.grpId == null) {
      this.stateFiltro.grpId = '';
    }

    this._usuarioHttpService
      .getUsuarios(filtro, page - 1)
      .subscribe(result => {
        this.usuarioService.state.data = result;
        this.pageIndex = this.usuarioService.state.data.number + 1;
      })
      .add(() => {
        this.usuarios = Object.assign([], this.usuarioService.state.data.content);

        this._appService.progressSpinnerDlg = false;
      });
  }

  /**
   * Função para buscar por paginação;
   * @param event
   */
  pageChanged(event: any) {
    this._appService.progressSpinnerDlg = true;

    const filtro = this.stateFiltro;

    if (this.stateFiltro.grpId == null) {
      this.stateFiltro.grpId = '';
    }

    this._usuarioHttpService
      .getUsuarios(filtro, event - 1)
      .subscribe(
        result => {
          this.usuarioService.state.data = result;
          this.pageIndex = this.usuarioService.state.data.number + 1;
          this.usuarioService.state.page = result.number;
        },
        error => {
          console.log(error);
        }
      )
      .add(() => {
        this.usuarios = Object.assign([], this.usuarioService.state.data.content);
        this._appService.progressSpinnerDlg = false;
      });
  }

  get stateFiltro() {
    return this.usuarioService.state.filtro;
  }

  /**
   * Função para inativar um usuario
   * @param id
   */
  async ativarInativar(usuario: Usuario) {
    let confirmed;

    if (usuario.ativo) {
      confirmed = await this._appService.fireSwalAsync('Atenção!', `Deseja realmente inativar o usuário?`, 'Inativar');
    } else {
      confirmed = await this._appService.fireSwalAsync('Atenção!', `Deseja realmente ativar o usuário?`, 'Ativar');
    }

    if (confirmed) {
      this._appService.progressSpinnerDlg = true;

      this._usuarioHttpService
        .ativarInativar(usuario.usuId)
        .subscribe(
          result => {
            this._messageService.success('Atenção', `Usuário ${usuario.ativo ? 'inativado' : 'ativado'} com sucesso.`);
          },
          error => {
            console.info(error);
            handleErrorMessage(this._messageService, error);
          }
        )
        .add(() => {
          this.filtrar(this.usuarioService.state.data.number + 1);
          this._appService.progressSpinnerDlg = false;
        });
    }
  }

  compareGrupo(obj1: any, obj2: any) {
    let b: boolean;
    b = obj1 && obj2 ? obj1.grpId === obj2.grpId : obj1 === obj2;
    return b;
  }
}
